import script from "./MintCollateralLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./MintCollateralLegend.vue?vue&type=script&setup=true&lang=js"

import "./MintCollateralLegend.vue?vue&type=style&index=0&id=4ca28b3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca28b3e"]])

export default __exports__